import { fontSize } from '@core-ds/primitives';

export default fontSize;
